/**
 * Frontend mirror of the backend `PermissionsNames` enum
 * (oa/backend/src/services/table-bound/permissions/PermissionsNames.ts).
 *
 * The backend remains the source of truth for permission names; keep the two in sync.
 */
export enum PermissionName {
  Admin = 'admin',
  OaCoordinator = 'oa-coordinator',
  OaAssistant = 'oa-assistant',
  OaClient = 'oa-client',
  SrWorker = 'sr-worker',
  SrClient = 'sr-client',
  Financial = 'financial',
  Personal = 'personal',
  LeaveManage = 'leave:manage',
  LeaveReadOwn = 'leave:read-own',
  AttendanceTableManage = 'attendance-table:manage',
  StatisticsRead = 'statistics:read',
  TagsManage = 'tags:manage',
  TagAssignmentsManage = 'tag-assignments:manage',
  Superadmin = 'superadmin',
}
